export default {
  name: 'MTooltipGrid',
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    open() {
      if (this.isOpen) {
        return;
      }
      this.isOpen = true;
    },
    close() {
      if (!this.isOpen) {
        return;
      }
      this.isOpen = false;
    },
  },
};
